import { render, staticRenderFns } from "./UserFollowers.vue?vue&type=template&id=608c3231&scoped=true&"
import script from "./UserFollowers.vue?vue&type=script&lang=js&"
export * from "./UserFollowers.vue?vue&type=script&lang=js&"
import style0 from "./UserFollowers.vue?vue&type=style&index=0&id=608c3231&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608c3231",
  null
  
)

export default component.exports